<div *ngIf="isOpen" class="modal-bg">

    <div class="modal-card">
        <h5>Sell-In Details: </h5>
        <div class="details-container">

            <div class="row-div">
                <div class="details-div">
                    <label for="">Transaction ID:</label>
                    <input type="text" [value]="details.transaction_id ?? 'N/A'" disabled>
                </div>
                <div class="details-div">
                    <label for="">Wallet:</label>
                    <input type="text" [value]="details.wallet ?? 'N/A'" disabled>
                </div>
            </div>

            <div class="row-div">
                <div class="details-div">
                    <label for="">Source Username:</label>
                    <input type="text" [value]="details.source ?? 'N/A'" disabled>
                </div>
                <div class="details-div">
                    <label for="">Source User Level:</label>
                    <input type="text" [value]="details.source_user_level ?? 'N/A'" disabled>
                </div>
            </div>

            <div class="row-div">
                <div class="details-div">
                    <label for="">Target Username:</label>
                    <input type="text" [value]="details.target ?? 'N/A'" disabled>
                </div>
                <div class="details-div">
                    <label for="">Target User Level:</label>
                    <input type="text" [value]="details.target_user_level ?? 'N/A'" disabled>
                </div>
            </div>
            
            <div class="row-div">
                <div class="details-div">
                    <label for="">Transaction Date:</label>
                    <input type="text" [value]="details.transaction_date ?? 'N/A'" disabled>
                </div>
                <div class="details-div">
                </div>
            </div>

            <div class="row-div">
                <div class="details-div">
                    <label for="">Type:</label>
                    <input type="text" [value]="details.type ?? 'N/A'" disabled>
                </div>
                <div class="details-div">
                    <label for="">Sub-type:</label>
                    <input type="text" [value]="details.subtype ?? 'N/A'" disabled>
                </div>
            </div>
            <div class="row-div">
                <div class="details-div">
                    <label for="">Amount:</label>
                    <input type="text" [value]="details.amount ? ('₱'+details.amount) : 'N/A'" disabled>
                </div>
                <div class="details-div">
                    <label for="">Target Initial Balance:</label>
                    <input type="text" [value]="details.target_initial_balance ? ('₱'+details.target_initial_balance) : 'N/A'" disabled>
                </div>
                <div class="details-div">
                    <label for="">Target End Balance:</label>
                    <input type="text" [value]="details.target_end_balance ? ('₱'+details.target_end_balance) : 'N/A'" disabled>
                </div>
            </div>
    
        </div>
        <button (click)="closeModal()" class="close-button"> Close </button>
    
    </div>

</div>